import { especificarAsunto } from './especificarAsunto';

new especificarAsunto();